import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { PageHeader } from '@/components/ui/PageHeader'
import { Suspense } from 'react'
import { DatabricksConnectionStatus } from './DatabricksConnectionStatus'
import { PlatformBreadcrumbs } from './PlatformBreadcrumbs'
import { RedisMenu } from './RedisMenu'

export function PlatformDatabricksPage() {
  return (
    <>
      <PageHeader className="pr-3" title={<PlatformBreadcrumbs title="Databricks" />}>
        <RedisMenu />
      </PageHeader>
      <TablePageContainer>
        <div className="flex h-full w-full items-center justify-center pb-5">
          <QueryErrorBoundary errorMessage="Failed to get Databricks status">
            <Suspense fallback={<LoadingComponent text="Checking Databricks status..." />}>
              <DatabricksConnectionStatus />
            </Suspense>
          </QueryErrorBoundary>
        </div>
      </TablePageContainer>
    </>
  )
}
